/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */

export default () => {
  self.addEventListener('message', async (event) => {
    const { formValues, filesToSend, nameSlug } = event.data;

    if (filesToSend?.length) {
      importScripts('https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js');
      const zip = new JSZip();

      filesToSend.forEach((file) => {
        zip.file(file.name, file);
      });

      const zippedFiles = await zip.generateAsync({ type: 'uint8array' }).then(
        (data) =>
          new File([data], `${nameSlug}.zip`, {
            lastModified: Date.now(),
            type: 'application/zip'
          })
      );

      postMessage({ formValues, zippedFiles });
    }
  });
};
